










































import {Component, Prop, Vue} from 'vue-property-decorator'
import {State, Action, Getter} from 'vuex-class'
import AuthRequest from '../../model/request/AuthRequest'
import * as Helpers from '@/helpers'

@Component
export default class SignInView extends Vue {
  @Action('auth/signIn') signIn?: Function
  model = new AuthRequest()

    created() {
        if (Helpers.isLogged()) {
            if (Helpers.isSac()) {
                this.$router.replace('/reports/delivery/sac')
            } else {
                this.$router.replace('/cockpit')
            }
        }
    }
}
